/**
 * "Not For Sale" chip for prototype/promo Palworld TCG printings. Promo (PR)
 * cards are handed out at events, pre-release demos and in product bundles and
 * carry the Not For Sale line instead of a retail product code, so they never
 * have an MSRP — only a secondary-market value.
 */
export function NotForSaleBadge({ note, className = "" }: { note?: string; className?: string }) {
  const label = note || "Promo printing distributed at events or in product bundles (Not For Sale).";
  return (
    <span
      tabIndex={0}
      role="note"
      title={`Not For Sale — ${label}`}
      aria-label={`Not For Sale promo card. ${label}`}
      className={`inline-flex items-center gap-1 rounded-md border border-orange-500/40 bg-orange-500/15 px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide text-orange-300 ${className}`}
    >
      Not For Sale
    </span>
  );
}
